<template>
  <div class="overlay">
    <div class="column overlay-content q-pa-md flex-1">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "BasePageOverlay",
};
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($white, 0.8);
  z-index: 1;
}

.overlay-content {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $control-border;
  box-shadow: 0 4px 4px rgba($black, 0.25);
}
</style>
